import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import React, { useEffect, useRef, useState } from 'react';
import { useGlobalState } from '../../../../context/GlobalStateContext';
import { CustomAppLayout } from '../../../layout';
const _preserve = React.version;


//import { useStoreAdmin } from '../../../../context/useStoreAdmin';

import { Box, Button, Container, FormField, KeyValuePairs, Link, SpaceBetween, Table } from '@cloudscape-design/components';
import Header from "@cloudscape-design/components/header";
import { mdiAlert, mdiAlertOctagon, mdiCheckCircle, mdiHelpCircle, mdiMagnify, mdiTriangle } from '@mdi/js';
import Icon from '@mdi/react';
import GaugeComponent from 'react-gauge-component';
import Favorites from '../../../../../components/extras/Favorites';
import MPModal from '../../../../../components/MPModal';
import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';
import { btnIconForm } from '../../../../../resources/types';
import { buildBreadcrumbItems, getCookie, getUrlVersion, setLoading, setParameters } from '../../../../commons/functions';

export const ReportsEDVRiskPage = () => {
    const { idUser, data, menu, parameters } = useGlobalState();
    useGlobalState();



    const [preflights, setPreflights] = useState<any[]>([]);
    const [preflight, setPreflight] = useState<any>();

    const mountedRef = useRef(false);
    useEffect(() => {
        const handleHashChange = () => {
            const hash = window.location.hash;
            const params = new URLSearchParams(hash.split("?")[1]);
            const id = params.get("id");
            if (id) {
                if (!mountedRef.current) {
                    mountedRef.current = true;
                }
                handleGetPreFlight(parseInt(id));
            } else {
                setPreflight(undefined);
                if (!mountedRef.current) {
                    mountedRef.current = true;
                }
            }
        };

        window.addEventListener("hashchange", handleHashChange);
        // also trigger once on mount
        handleHashChange();

        return () => window.removeEventListener("hashchange", handleHashChange);
    }, []);

    const handleGetPreFlight = async (id: number) => {
        try {
            setLoading(true);
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/admin/edv/risk/preflights/results/preflight',
                    'JWT': getCookie("JWT"),
                },
                body: JSON.stringify({ idPreflightResult: id })
            });
            if (!response.ok) { throw new Error(`HTTP error: ${response.status}`); }

            const data = await response.json();
            if (data && data.preFlight) {
                setPreflight(data.preFlight);
            }
        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);
        }
    };
    const handleGetPreFlights = async () => {
        try {
            if (parameters.year && parameters.month) {
                setLoading(true);
                const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'x-routing': '/private/admin/edv/risk/preflights/results/list',
                        'JWT': getCookie("JWT"),
                    },
                    body: JSON.stringify({ month: parameters.month, year: parameters.year })
                });
                if (!response.ok) { throw new Error(`HTTP error: ${response.status}`); }

                const data = await response.json();
                if (data && data.preFlights) {
                    setPreflights(data.preFlights);
                }
            }
        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        //handleGetPreFlights();
    }, []);
    const results = preflight?.result?.results || null;
    const result = preflight?.result || null;
    const colors = ["green", "orange", "red", "gray"]
    const colors2 = ["green", "orange", "red"].reverse();


    return (
        <CustomAppLayout
            toolsHide={true}
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <SpaceBetween size="s">

                    {!!preflight && !!result && !!results && (
                        <SpaceBetween size="s" direction="vertical">
                            <Header
                                actions={<Button variant='link' onClick={() => {
                                    window.location.hash = `#reports/edv/risk`;
                                }}>Volver</Button>}
                            >{preflight.displayName} (ID #{preflight.idPreflightResult})</Header>
                            <Container
                                header={<Header
                                    actions={`Tipo: ${preflight.preFlight}`}
                                    description={
                                        <>
                                            {Math.round((result.subTypes?.[0]?.result ?? 0) * 100) / 100} (FT) X
                                            {Math.round((result.subTypes?.[1]?.result ?? 0) * 100) / 100} (FH) =
                                            {Math.round((results?.score ?? 0) * 100) / 100}

                                        </>

                                    }>
                                    Puntaje global
                                </Header>}

                            >

                                <KeyValuePairs
                                    columns={4}
                                    items=
                                    {[
                                        ...result.actions.slice().reverse().map((item: any, index: number) => (
                                            {
                                                label: `${item.low}-${item.high > 9999 ? "∞" : item.high}`,
                                                value: (
                                                    <FormField constraintText={
                                                        <SpaceBetween direction="vertical" size="xs">
                                                            <Box textAlign='center'>
                                                                {results.score >= item.low && results.score <= item.high ? <Icon rotate={180} path={mdiTriangle} color={colors2[index]} size={1} /> : "\u00A0"}
                                                            </Box>
                                                            <Box textAlign='center'>
                                                                {item.title}
                                                            </Box>
                                                        </SpaceBetween>
                                                    }>

                                                    </FormField>
                                                )
                                            })),
                                        {
                                            label: "",
                                            value:

                                                <GaugeComponent
                                                    value={results.score} type="semicircle" minValue={0} maxValue={10} style={{ width: 250 }}
                                                    arc={{
                                                        width: 0.2, padding: 0.015, cornerRadius: 2, subArcs:
                                                            result.actions.slice().reverse().map((item: any, index: number) => (
                                                                { limit: item.high, color: colors2[index], showTick: true, tooltip: { text: item.title } }
                                                            ))
                                                    }}
                                                    pointer={{
                                                        type: "blob", color: "#e0e0e0", length: 0.7, width: 8, maxFps: 30
                                                    }}
                                                    labels={{
                                                        valueLabel: {
                                                            formatTextValue: e => "".concat(e.toFixed(2), ""),
                                                            style: { fontSize: "40px", fill: "#0f141a", fontWeight: "bold" }
                                                        },
                                                        tickLabels: {
                                                            type: "outer",
                                                            defaultTickValueConfig: {
                                                                formatTextValue: e => "".concat(e, ""),
                                                                style: { fontSize: "16px", fill: "#0f141a" }
                                                            },
                                                            defaultTickLineConfig: { color: "#0f141a", length: 4, width: 1 }
                                                        }
                                                    }}
                                                />
                                        }
                                    ]}
                                />
                            </Container>
                            {result.subTypes?.map((subType: any, index: number) => (

                                <Container key={index}
                                    footer={<Header variant="h1">Puntaje: {Math.round((subType.result ?? 0) * 100) / 100}</Header>}
                                    header={<Header>
                                        {subType.title}

                                        {subType.questions.map((question: any, qIndex: number) => (
                                            <SpaceBetween direction="vertical" size="l">
                                                <Header variant="h3" key={qIndex} description={question.subQuestion}>{question.question}</Header>


                                                {question.type === "NUMERIC.RANGE" && (
                                                    <KeyValuePairs
                                                        columns={question.ranges.length}
                                                        items={question.ranges.slice().reverse().map((range: any, rIndex: number) => ({
                                                            // Fixed: Removed the extra colon and curly braces inside the object
                                                            label: `${range.low}-${range.high > 9999 ? "∞" : range.high}`,
                                                            info: <Link variant="info">Peso: {range.weight}</Link>,
                                                            value: (
                                                                // You likely just want the weight or a link here
                                                                <SpaceBetween direction="vertical" size="xs">
                                                                    <Box textAlign='center' >
                                                                        <Link variant="awsui-value-large">
                                                                            {question.value >= range.low && question.value <= range.high ? question.value : null}
                                                                        </Link>
                                                                    </Box>
                                                                    <Box textAlign='center' >
                                                                        <Link variant="awsui-value-large">
                                                                            {question.value >= range.low && question.value <= range.high ?
                                                                                <Icon path={mdiTriangle} color={range.range === "high" ? "green" : range.range === "mid" ? "orange" : range.range === "low" ? "red" : "gray"} size={1} /> : "\u00A0"}
                                                                        </Link>
                                                                    </Box>
                                                                </SpaceBetween>
                                                            )
                                                        }))}
                                                    />
                                                )}


                                                {question.type === "OPTION" && (
                                                    <KeyValuePairs
                                                        columns={question.ranges.length}
                                                        items={question.ranges.slice().reverse().map((range: any, rIndex: number) => ({
                                                            // Fixed: Removed the extra colon and curly braces inside the object
                                                            label: range.title,
                                                            info: <Link variant="info">Peso: {range.weight}</Link>,
                                                            value: (
                                                                // You likely just want the weight or a link here
                                                                <SpaceBetween direction="vertical" size="xs">
                                                                    <Box textAlign='center' >
                                                                        <Link variant="awsui-value-large">
                                                                            {question.value == range.weight ? question.eval : null}
                                                                        </Link>
                                                                    </Box>
                                                                    <Box textAlign='center' >
                                                                        <Link variant="awsui-value-large">
                                                                            {question.value == range.weight ?
                                                                                <Icon path={mdiTriangle} size={1} color={range.range === "high" ? "green" : range.range === "mid" ? "orange" : range.range === "low" ? "red" : "gray"} /> : "\u00A0"}
                                                                        </Link>
                                                                    </Box>
                                                                </SpaceBetween>
                                                            )
                                                        }))}
                                                    />
                                                )}
                                            </SpaceBetween>

                                        ))}

                                    </Header>}>
                                </Container>
                            ))
                            }
                        </SpaceBetween >

                    )}

                    {
                        !preflight && (
                            <SpaceBetween size="s">
                                <Header variant="h1" actions={<Favorites />}>Mitigación de riesgo</Header>
                                <SpaceBetween size="s" direction="horizontal">
                                    <FormField label="Periodo">

                                        <MPModal
                                            width={120}
                                            today prevMonth nextMonth
                                            end={new Date()}
                                            date={`${parameters.period}`}
                                            onConfirm={(date) => {
                                                setParameters({ ...parameters, period: date.period, month: date.month, year: date.year });
                                            }}
                                        />
                                    </FormField>
                                    <FormField label="&nbsp;">
                                        <Button style={{ root: btnIconForm }}
                                            disabled={parameters.period === ""}
                                            onClick={() => handleGetPreFlights()}><Icon path={mdiMagnify} size={1} /></Button>
                                    </FormField>
                                </SpaceBetween>
                                <Table
                                    variant="embedded"
                                    stickyHeader={true}
                                    columnDefinitions={[
                                        {
                                            id: 'status',
                                            header: '',
                                            cell: (item) => item.result.results.result === 0 ?
                                                <Icon path={mdiCheckCircle} size={1} color='green' /> :
                                                item.result.results.result === 1 ? <Icon path={mdiAlert} size={1} color='orange' /> :
                                                    item.result.results.result === 2 ? <Icon path={mdiAlertOctagon} size={1} color='red' /> :
                                                        <Icon path={mdiHelpCircle} size={1} color='gray' />
                                        },
                                        {
                                            id: 'preFlight',
                                            header: 'ID/Fecha',
                                            cell: (item) => <FormField label={<Link
                                                onClick={() => {
                                                    window.location.hash = `#reports/edv/risk?id=${item.idPreflightResult}`;
                                                }}
                                            >{item.idPreflightResult}</Link>}>
                                                {item.dateResult}
                                            </FormField>
                                        },
                                        {
                                            id: 'type',
                                            header: 'Tipo',
                                            cell: (item) => <FormField label={item.displayName}>
                                                {item.preFlight}
                                            </FormField>
                                        },
                                        {
                                            id: 'result',
                                            header: 'Estado',
                                            cell: (item) => item?.result?.results?.action
                                        },
                                    ]} items={preflights} loadingText="Cargando..." />


                            </SpaceBetween>
                        )
                    }

                </SpaceBetween >
            }
        />
    )
};
